import { Injectable } from '@angular/core';
import { DictionaryField } from '@gk/gk-modules';
import { Observable, of } from 'rxjs';
import { PARRequestType } from './request-type.model';

@Injectable({
  providedIn: 'root',
})
export class PARRequestTypeService {
  private readonly requestTypes: DictionaryField[] = [
    new DictionaryField(
      PARRequestType.ActAmendment,
      'PLANNING_ACT_REQUEST.REQUEST_TYPE.ACT_AMENDMENT',
    ),
    new DictionaryField(
      PARRequestType.ActPreparation,
      'PLANNING_ACT_REQUEST.REQUEST_TYPE.ACT_PREPARATION',
    ),
  ];
  private requestTypeDictionary: Observable<DictionaryField[]>;

  get(): Observable<DictionaryField[]> {
    if (!this.requestTypeDictionary) {
      this.requestTypeDictionary = of(this.requestTypes);
    }
    return this.requestTypeDictionary;
  }
}
